<div>
  <app-employees-per-pro-filters *ngIf="years"
    [years]="years"
    (search)="searchData($event)">
  </app-employees-per-pro-filters>
  <mat-divider></mat-divider>
  <app-employees-per-pro-pie-chart *ngIf="data"
    [title]="text"
    [subtitle]="subtitle"
    [data]="data">
  </app-employees-per-pro-pie-chart>
</div>
